import React from 'react';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import { PageFEDSA } from 'components/layout';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const FedsaLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { key: 'tab-1', text: 'File Upload', tabPanelId: 'tab_1', path: '/noneusuppliers/fileupload' },
    {
      key: 'tab-2',
      text: 'Manual Entry',
      tabPanelId: 'tab_2',
      path: '/noneusuppliers/manualentry',
    },
  ];

  const activeTab = tabs.find((tab) => location.pathname.includes(tab.path))?.tabPanelId || 'tab_1';

  const handleTabChange = (tabId) => {
    const selectedTab = tabs.find((tab) => tab.tabPanelId === tabId);
    if (selectedTab) {
      navigate(selectedTab.path);
    }
  };

  return (
    <PageFEDSA className="file-upload-container">
      <Tabs
        tabs={tabs.map(({ key, text, tabPanelId }) => (
          <Tab key={key} text={text} tabPanelId={tabPanelId} />
        ))}
        tabPanels={[
          <TabPanel key={activeTab} tabPanelId={activeTab}>
            <Outlet />
          </TabPanel>,
        ]}
        defaultActiveTab={activeTab}
        onTabChanged={handleTabChange}
        ariaLabel="Supplier Tabs"
      />
    </PageFEDSA>
  );
};

export default FedsaLayout;
